import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "The ES6 Cheatsheet story and results",
  "description": "",
  "published": "2016-08-17T00:00:00.000Z",
  "redirect_from": ["/blog/the-es6-cheatsheet-story-and-results/swizec/6936"],
  "categories": "Business, Side Projects",
  "hero": "./img/cover.png"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p><a parentName="p" {...{
        "href": "https://es6cheatsheet.com"
      }}>{`[`}{`caption width="545" align="alignnone"`}{`]`}<figure parentName="a" {...{
          "className": "gatsby-resp-image-figure",
          "style": {
            "textAlign": "center",
            "fontStyle": "italic"
          }
        }}>{`
    `}<span parentName="figure" {...{
            "className": "gatsby-resp-image-wrapper",
            "style": {
              "position": "relative",
              "display": "block",
              "marginLeft": "auto",
              "marginRight": "auto",
              "maxWidth": "890px"
            }
          }}>{`
      `}<span parentName="span" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "60.98654708520179%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/svg+xml,%3csvg%20xmlns=\\'http://www.w3.org/2000/svg\\'%20width=\\'400\\'%20height=\\'245\\'%20viewBox=\\'0%200%20400%20245\\'%20preserveAspectRatio=\\'none\\'%3e%3cpath%20d=\\'M13%20111v48h181V62H13v49m191%200v48h181V62H204v49\\'%20fill=\\'%23d3d3d3\\'%20fill-rule=\\'evenodd\\'/%3e%3c/svg%3e')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/cb6dd442fb2c11fb62487c2f8a6f3f87/ca0a1/cover.webp 223w", "/static/cb6dd442fb2c11fb62487c2f8a6f3f87/75680/cover.webp 445w", "/static/cb6dd442fb2c11fb62487c2f8a6f3f87/8d1ba/cover.webp 890w", "/static/cb6dd442fb2c11fb62487c2f8a6f3f87/a70f5/cover.webp 945w"],
                "sizes": "(max-width: 890px) 100vw, 890px",
                "type": "image/webp"
              }}></source>{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/cb6dd442fb2c11fb62487c2f8a6f3f87/e92b6/cover.png 223w", "/static/cb6dd442fb2c11fb62487c2f8a6f3f87/e66bf/cover.png 445w", "/static/cb6dd442fb2c11fb62487c2f8a6f3f87/4ef49/cover.png 890w", "/static/cb6dd442fb2c11fb62487c2f8a6f3f87/40601/cover.png 945w"],
                "sizes": "(max-width: 890px) 100vw, 890px",
                "type": "image/png"
              }}></source>{`
          `}<img parentName="picture" {...{
                "className": "gatsby-resp-image-image",
                "src": "/static/cb6dd442fb2c11fb62487c2f8a6f3f87/4ef49/cover.png",
                "alt": "ES6 Cheatsheet",
                "title": "ES6 Cheatsheet",
                "loading": "lazy",
                "style": {
                  "width": "100%",
                  "height": "100%",
                  "margin": "0",
                  "verticalAlign": "middle",
                  "position": "absolute",
                  "top": "0",
                  "left": "0"
                }
              }}></img>{`
        `}</picture>{`
    `}</span>{`
    `}<figcaption parentName="figure" {...{
            "className": "gatsby-resp-image-figcaption"
          }}>{`ES6 Cheatsheet`}</figcaption>{`
  `}</figure>{` ES6 Cheatsheet`}{`[`}{`/caption`}{`]`}</a></p>
    <p>{`On July 28th I launched a mini product – my `}<a parentName="p" {...{
        "href": "https://es6cheatsheet.com/"
      }}>{`Interactive ES6 CheatSheet`}</a>{`.`}</p>
    <p>{`I started noodling on the initial nugget of idea on a Monday. `}<em parentName="p">{`“Hmmm, a lot of people have been complaining that React+D3 is hard because they can’t read ES6”`}</em>{`. That Thursday I got an email from JavaScript Weekly reminding me that many months ago I had reserved an ad spot for July 28th.`}</p>
    <p>{`Shit, don’t want to let a few hundred bucks go to waste. Fine, we’ll build and launch a product by then. Totally reasonable.`}</p>
    <p>{`My noodling `}<em parentName="p">{`“I should help with ES6”`}</em>{` thought became a product idea – make a cheatsheet. But with so many ES6 cheatsheets out there, how can I stand out? Let’s make it interactive!`}</p>
    <p>{`On Friday I bought `}<a parentName="p" {...{
        "href": "https://es6cheatsheet.com"
      }}>{`es6cheatsheet.com`}</a>{` and spent 5 hours moving all my web properties to https. That was a massive yak shaving, but it needed to be done. Been putting it off for too long.`}</p>
    <p>{`I had shaved another useful Yak in April – the framework of React components for landing pages. Throwing a website together and making it look nice was as simple as `}<inlineCode parentName="p">{`<Section><Left><p>bla</p></Left></Section>`}</inlineCode>{`.`}</p>
    <p>{`That took an evening. Building the CodePen interactive examples took two very long nights.`}</p>
    <p>{`On Monday - July 26th - the first couple of friends got to see my cheatsheet and give feedback. I tweaked some things, ignored some other things, and spent the next night building a purchase mechanism. Nothing fancy: replace most of the cheatsheet with a fadeout and a Buy button.`}</p>
    <p>{`Click the button, do the Gumroad flow, redirect back to page, put token in local storage, hide fadeout. Done. Every time page loads, check local storage. No token -> fadeout. Token -> show all.`}</p>
    <p>{`Easy for anyone to hack, but that’s okay. The ease of not having a server and a database and keeping everything frontend is totally worth it.`}</p>
    <p>{`On Wednesday night, I added `}<a parentName="p" {...{
        "href": "http://www.smartbribe.com/"
      }}>{`SmartBribe`}</a>{` – a service to help you bribe users to share your content. If you share on Twitter, you get free stuff. If you also send an email, you get more free stuff. Easy to integrate, makes every conversion more valuable.`}</p>
    <p>{`On Thursday morning - July 28th - the link went out to 100,000 subscribers to Javascript Weekly. 1 week after inception.`}</p>
    <p>{`A few days later it also went out to Pony Foo Weekly. A much smaller list, but the clickthrough rate was higher. Probably because I had more time to think through the marketing blurb.`}</p>
    <h2 {...{
      "id": "heres-what-happened-in-those-19-days"
    }}>{`Here’s what happened in those 19 days`}</h2>
    <p><img parentName="p" {...{
        "src": "https://swizec.com/blog/wp-content/uploads/2016/08/Screen-Shot-2016-08-17-at-00.06.19-1024x360.png",
        "alt": "ES6 cheatsheet analytics"
      }}></img></p>
    <p>{`5,853 people visited es6cheatsheet.com. A quarter of them came back a second time. The average visit was a bit over a minute long.`}</p>
    <p>{`Which is low for something like this. I hope `}<em parentName="p">{`users`}</em>{` spent more time on the page. It’s hard to tell because the landing page and the actual product are the same thing.`}</p>
    <p>{`Of those 5,853 people, 1,185 bought on Gumroad. That means at the very least they gave me their email, which I can now use to build a relationship, do market research, and maybe sell other products. Email marketing at its finest.`}</p>
    <p>{`To put those thousand emails into context: My email list went from 3,xxx to 4,xxx. That’s a big jump and I’m really happy it happened.`}</p>
    <p><img parentName="p" {...{
        "src": "https://swizec.com/blog/wp-content/uploads/2016/08/Screen-Shot-2016-08-16-at-23.41.01-1024x486.png",
        "alt": "ES6 cheatsheet sales"
      }}></img></p>
    <p>{`Of those 1,185 users, 65 became paying customers and I made $314. Not a lot of money, but money wasn’t the point. Gumroad just makes it easy to collect $$ as well as emails. Might as well allow people to support my work.`}</p>
    <p>{`The max price paid was $50, which is pretty crazy, and the lowest was $1, which I guess is fair. Average price paid was $4.8, which is interesting because my intuition was that this is a $5 product.`}</p>
    <p>{`My main takeaway is that the ES6 Cheatsheet works really well as a lead magnet, not so well as a paid product. I’m going to leverage it for getting subscribers in even more places.`}</p>
    <p>{`And it’s going to stay free.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      